import { useState } from "react"
import { useAddBallersMutation } from "../store"
import { GoChevronLeft, GoChevronRight } from "react-icons/go"

function CheckIn({ courtId, setcheckInOpen }) {
    const [AddBallers, results] = useAddBallersMutation()
    const [groupName, setGroupName] = useState('')
    const [players, setPlayers] = useState(1)
    const [playersNeeded, setPlayersNeeded] = useState(0)
    const [timeFrom, setTimeFrom] = useState(0)
    const [timeTo, setTimeTo] = useState(0)
    const [timeNow, setTimeNow] = useState(new Date().toLocaleTimeString('en-US',
        {
            hour12: false,
            hour: "numeric",
            minute: "numeric"
        }))
    const [nextPage, setnextPage] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
        var tdate = new Date(Date.now())
        var today = `${tdate.getUTCDate()}${tdate.getUTCMonth()}`
        console.log(today);
        let ballers = {
            name: groupName ? groupName.charAt(0).toUpperCase() + groupName.slice(1) : '',
            players,
            playersNeeded,
            timeFrom,
            timeTo,
            date: today,
            courtId
        }

        AddBallers(ballers);
        setcheckInOpen(false);
    }


    const handlePlayersChange = (e) => {
        const newValue = e.target.value;
        if (e.target.name === 'players') {
            if (newValue > 10 && newValue < 20)
                setPlayers(newValue - 10)
            else if (newValue > 20)
                setPlayers(10)
            else if (newValue <= 1)
                setPlayers(1)
            else
                setPlayers(Math.round(newValue))
        }
        else if (e.target.name === 'playersNeeded') {
            if (newValue > 10)
                setPlayersNeeded(10)
            else if (newValue <= 0)
                setPlayersNeeded(0)
            else
                setPlayersNeeded(Number(Math.round(newValue)).toString())
        }

    }


    return (<>
        <button className=" text-white p-1 pr-2 flex justify-start items-center rounded border border-orange-500"
            onClick={() => setcheckInOpen(false)}>
            <GoChevronLeft className="inline text-xl" />Cancel
        </button>
        <form onSubmit={handleSubmit} >
            {!nextPage ? <div className="text-white text-l grid  grid-cols-3 grid-rows-auto gap-3 mt-2 p-1">
                <label className=" pt-1 col-span-3 row-span-1 text-center font-bold text-xl ">Details</label>
                <label className=" p-1 font-bold text-md flex self-center"> Name:</label>
                <input className="col-span-2 my-1 p-2 text-md rounded border border-orange-500" type="text" placeholder="No name"
                    onChange={(e) => { /^$|^[a-zA-ZΑ-Ωα-ωίϊΐόάέύϋΰήώ ]+$/.test(e.target.value) ? setGroupName(e.target.value) : console.log('name error'); }}
                    value={groupName} minLength="4" maxLength="15" size="11" ></input>

                <div className="col-span-2 flex flex-col">
                    <label className=" p-1 font-bold text-md flex self-center"> Players:</label>
                    <input className="w-full rounded border border-orange-500" type="range"
                        onChange={(e) => { setPlayers(e.target.value) }} value={players} min={1} max={10}></input>
                </div>
                <input className="p-1 pl-3 my-1 font-bold text-lg col-span-1 rounded border border-orange-500" type="number"
                    onChange={(e) => { handlePlayersChange(e) }} name="players" value={players} step="1" maxLength="2" min={1} max={10}></input>

                <div className="col-span-2 flex flex-col">
                    <label className=" p-1 font-bold text-md flex self-center"> Need Players:</label>
                    <input className="w-full rounded border border-orange-500" type="range"
                        onChange={(e) => { setPlayersNeeded(e.target.value) }} value={playersNeeded} min={0} max={10}></input>
                </div>
                <input className="p-1 pl-3 my-1 font-bold text-lg col-span-1 rounded border border-orange-500" type="number"
                    onChange={(e) => { handlePlayersChange(e) }} name="playersNeeded" value={playersNeeded} step="1" maxLength="2" placeholder={0} min={1} max={10}></input>

                <button className=' col-span-3 font-bold rounded border p-2 border-orange-500' onClick={() => setnextPage(true)}
                    type="submit">Next <GoChevronRight className="inline text-xl" /></button>
            </div> :
                <div className=" w-full text-white text-l grid grid-cols-2 grid-rows-auto gap-3 my-3 p-1">
                    <label className=" pt-1 col-span-2 text-center font-bold text-xl ">Play Time</label>

                    <div className="col-span-2 flex flex-row gap-3 justify-center">
                        <label className="p-2 font-bold "> From:</label>
                        <input className="w-max p-1 rounded border border-orange-500" type="time"
                            onChange={(e) => { setTimeFrom(e.target.value) }} value={timeFrom} required min={timeNow}></input>
                    </div>
                    <div className="col-span-2 flex flex-row gap-4 justify-center">
                        <label className=" p-2 font-bold"> Until:</label>
                        <input className="w-max p-1 rounded border border-orange-500" type="time"
                            onChange={(e) => { setTimeTo(e.target.value) }} value={timeTo} required min={timeFrom} ></input>
                    </div>
                    <button className=' col-span-2 text-black font-bold rounded p-2 bg-orange-500'
                        type="submit" >Check-in</button>
                </div>}
        </form>
    </>
    )


}

export default CheckIn